import api from './api';

const marketingPackService = {
  getFile: async (file) => {
    const response = await api.get(`/marketing-pack/${encodeURIComponent(file)}`);
    return response.data;
  },
};

export default marketingPackService;
